(function (root) {
  'use strict';
  function presentationValid(p) {
    return !!(p && typeof p.header_text === 'string' && typeof p.header_countdown === 'boolean' &&
      typeof p.product_countdown === 'boolean' && Number.isInteger(p.slide_seconds) && p.slide_seconds >= 3 && p.slide_seconds <= 15 &&
      Array.isArray(p.slides) && p.slides.length <= 5 && p.slides.every(s => s &&
        ['desktop_url', 'mobile_url', 'alt', 'heading', 'link'].every(k => typeof s[k] === 'string')) &&
      Array.isArray(p.slots) && p.slots.length <= 12 && p.slots.every(s => s &&
        typeof s.slot_id === 'string' && typeof s.collection_handle === 'string' && typeof s.title === 'string' &&
        typeof s.hidden === 'boolean' && Number.isInteger(s.count) && s.count >= 1 && s.count <= 24) &&
      new Set(p.slots.map(s => s.slot_id)).size === p.slots.length);
  }
  function valid(manifest, now) {
    return !!(manifest && manifest.schema_version === 1 &&
      /^[0-9a-f-]{36}$/i.test(manifest.occurrence_id) && Number.isSafeInteger(manifest.generation) && manifest.generation > 0 &&
      /^[0-9a-f]{64}$/.test(manifest.eligibility_ref) && presentationValid(manifest.presentation) &&
      Number.isFinite(Date.parse(manifest.effective_at)) && Number.isFinite(Date.parse(manifest.ends_at)) &&
      Date.parse(manifest.effective_at) <= now && now < Date.parse(manifest.ends_at));
  }
  function install(doc, options) {
    options = options || {};
    const clock = options.clock || Date.now;
    let manifest = null;
    try { manifest = JSON.parse(doc.querySelector('[data-ts-manifest]').textContent); } catch (_) { /* Baseline is safe. */ }
    const key = manifest ? 'textual-sales-dismissed:' + manifest.occurrence_id : '';
    let dismissed = false;
    try { dismissed = root.localStorage.getItem(key) === '1'; } catch (_) { /* Closing still works. */ }
    const all = (selector) => Array.from(doc.querySelectorAll(selector));
    function tick() {
      const active = valid(manifest, clock());
      all('[data-ts-mode]').forEach(node => { node.hidden = node.dataset.tsMode === 'active' ? !active : active; });
      all('[data-ts-header]').forEach(node => { node.hidden = !active || dismissed; });
      all('[data-ts-product]').forEach(node => {
        let eligibility = null;
        try { eligibility = JSON.parse(node.dataset.tsEligibility); } catch (_) { /* No unverified claim. */ }
        const scope = node.closest('form') || node.parentElement;
        const input = scope.querySelector('[name="id"]');
        const variant = input ? String(input.value) : node.dataset.tsVariant;
        node.hidden = !(active && manifest.presentation.product_countdown && eligibility &&
          eligibility.ref === manifest.eligibility_ref && Array.isArray(eligibility.variants) &&
          eligibility.variants.map(String).includes(variant));
      });
      if (!active) return;
      const seconds = Math.max(0, Math.ceil((Date.parse(manifest.ends_at) - clock()) / 1000));
      const text = Math.floor(seconds / 3600) + 'h ' + String(Math.floor(seconds % 3600 / 60)).padStart(2, '0') + 'm ' + String(seconds % 60).padStart(2, '0') + 's';
      all('[data-ts-clock]').forEach(node => { if (node.textContent !== text) node.textContent = text; });
    }
    const listeners = [];
    function listen(node, event, handler) { node.addEventListener(event, handler); listeners.push(() => node.removeEventListener(event, handler)); }
    all('[data-ts-dismiss]').forEach(button => listen(button, 'click', () => {
      dismissed = true;
      try { root.localStorage.setItem(key, '1'); } catch (_) { /* Optional storage. */ }
      tick();
    }));
    listen(doc, 'change', tick);
    listen(doc, 'variant:change', tick);
    listen(doc, 'visibilitychange', tick);
    const timers = [root.setInterval(tick, 1000)];
    all('[data-ts-slides]').forEach(container => {
      const slides = Array.from(container.querySelectorAll('[data-ts-slide]'));
      let index = 0;
      const show = n => { index = (n + slides.length) % slides.length; slides.forEach((slide, i) => { slide.hidden = i !== index; }); };
      if (!slides.length) return;
      show(0);
      container.querySelectorAll('[data-ts-slide-step]').forEach(button => listen(button, 'click', () => show(index + Number(button.dataset.tsSlideStep))));
      let paused = false;
      listen(container, 'mouseenter', () => { paused = true; });
      listen(container, 'mouseleave', () => { paused = false; });
      if (!root.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timers.push(root.setInterval(() => {
          if (!paused && !container.contains(doc.activeElement) && !doc.hidden) show(index + 1);
        }, Math.max(3, Math.min(15, Number(container.dataset.tsSlides) || 5)) * 1000));
      }
    });
    tick();
    return {tick, destroy: () => { timers.forEach(root.clearInterval); listeners.forEach(remove => remove()); }};
  }
  root.TextualSales = {valid, install};
  if (typeof module === 'object' && module.exports) module.exports = {valid};
  if (root.document && root.document.querySelector('[data-ts-manifest]')) {
    if (root.textualSalesInstance) root.textualSalesInstance.destroy();
    root.textualSalesInstance = install(root.document);
  }
})(typeof window === 'undefined' ? globalThis : window);
